import React from "react";
import InputWithIcon from "../../../commons/InputWithIcon";
import CustomSlider from "../../../commons/CustomSlider";

const XenoarcV3Setting = () => {
  return (
    <>
      <InputWithIcon
        // value={value}
        // onChange={(e) => setValue(e.target.value)}
        placeholder="Capital Location"
        rightIcon={"USDT"}
      />
      <CustomSlider setPercentage={() => {}} />
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="">Grid width</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
        <div>
          <label htmlFor="">Grid width exit</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="">Buy flag return</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
        <div>
          <label htmlFor="">Exit flag return</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="">Grid exit ratio</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
        <div>
          <label htmlFor="">Max drawdown</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="">Drawdown base point all exit</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
        <div>
          <label htmlFor="">All exit flag return</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="">Exit when non touch drowdown</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
        <div>
          <label htmlFor="">Exit when touch drowdown</label>
          <InputWithIcon
            // value={value}
            // onChange={(e) => setValue(e.target.value)}
            placeholder="Trade Size"
            rightIcon={"%"}
          />
        </div>
      </div>
    </>
  );
};
export default XenoarcV3Setting;
